export const FETCH_BANKS = 'FETCH_BANKS';
export const FETCH_CARDS = 'FETCH_CARDS';
export const FETCH_COMPANIES = 'FETCH_COMPANIES';

export const FETCH_BANKS_SUCCESS = 'FETCH_BANKS_SUCCESS';
export const FETCH_CARDS_SUCCESS = 'FETCH_CARDS_SUCCESS';
export const FETCH_COMPANIES_SUCCESS = 'FETCH_COMPANIES_SUCCESS';

export const FETCH_TAGS = 'FETCH_TAGS';
export const PATCH_TAGS = 'PATCH_TAGS';



// WEBPACK FOOTER //
// ./src/constants.ts